// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hyBPu","disabled":"styles_disabled__D93Ca"};